import React from "react"

import { useProductConfiguratorProductInfoContext } from "../../model/ProductConfiguratorProductInfoContext"
import {
  ProductConfiguratorSummaryCard,
  ProductConfiguratorSummaryCardProps
} from "./ProductConfiguratorSummaryCard"

type ProductConfiguratorSummaryCardConnectorProps = Pick<
  ProductConfiguratorSummaryCardProps,
  "showVariantKeysOnly" | "className"
>

function ProductConfiguratorSummaryCardConnectorComponent({
  showVariantKeysOnly,
  className
}: ProductConfiguratorSummaryCardConnectorProps) {
  const {
    productTitle,
    productImage,
    productInformation,
    isLoadingProductInformation
  } = useProductConfiguratorProductInfoContext()

  return (
    <ProductConfiguratorSummaryCard
      productTitle={productTitle}
      productImage={productImage}
      productInformation={productInformation}
      isLoadingProductInformation={isLoadingProductInformation}
      showVariantKeysOnly={showVariantKeysOnly}
      className={className}
    />
  )
}

export const ProductConfiguratorSummaryCardConnector = React.memo(
  ProductConfiguratorSummaryCardConnectorComponent
)
